function Header() {
  return (
    <section className="hero header">
      <div className="hero-head content has-text-centered">
        <p className="title is-1">Movie Quiz</p>
      </div>
    </section>
  )
}

export default Header